
<span v-show="visible" class="vnode__btn__group">
  <slot></slot>
</span>
